export default __webpack_public_path__ + "static/media/by_1.4fd662b2.mp3";